import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { useModal } from '@gluedigital/modal'
import UserAccount from './UserAccount/UserAccount'

import './Home.sass'
import 'src/components/ClientModal'

const Home = () => {
  const modal = useModal()
  const user = useSelector((s) => s.user)

  const cards = useMemo(() => {
    const list = sections.map((section) => {
      const hasAccess =
        user?.sections &&
        section.section?.some((e) => user.sections.includes(e))
      return { ...section, hasAccess }
    })
    list.sort((a, b) =>
      a.hasAccess ? (b.hasAccess ? 0 : -1) : b.hasAccess ? 1 : 0
    )
    return list
  }, [user])

  return (
    <div className="page" id="home">
      <div className="logo" />
      <div className="header-actions">
        <button onClick={() => modal.show('client-modal')} className="filled">
          <span className="icon icon-mail" />
          <span className="hide-desktop">
            <FormattedMessage id="manteinances-header.client" />
          </span>
        </button>
        <UserAccount />
      </div>
      {cards.map((card) => (
        <Link
          id={card.id}
          className={'home-card' + (card.hasAccess ? '' : ' disabled')}
          to={'/' + card.id}
        >
          <div className="image" />
          <h1>
            <FormattedMessage id={'home.' + card.id} />
          </h1>
        </Link>
      ))}
    </div>
  )
}

const sections = [
  { id: 'soc', section: ['S'] },
  { id: 'manteinance', section: ['M'] },
  { id: 'digital', section: ['I', 'P'] },
  { id: 'incidences', section: ['C'] },
  { id: 'surveillance' },
  { id: 'mobile' }
]

export default Home
